// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { VehicleAreaRoutes } from '@backoffice-frontend/vehicle-api'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VehicleAreaId } from './VehicleAreaId'

import { VehicleAreaNavigation } from './VehicleAreaNavigation'

const LazyVehicleComponent = lazy(() => import('./VehicleArea'))

const VehicleComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleArea = {
  id: VehicleAreaId,
  requiredRight: BoumRight.AREA_VEHICLE,
  NavigationComponent: VehicleAreaNavigation,
  route: {
    path: VehicleAreaRoutes.route,
    component: VehicleComponent,
  },
}
